<template>
  <div class="page-no-access">无访问权限，请联系系统管理员</div>
</template>

<script>
export default {
  name: 'NoAccess',
};
</script>

<style scoped>
.page-no-access {
  text-align: center;
  font-size: 16px;
  color: #606266;
  padding-top: 0.8rem !important;
}
</style>
